<template>
  <md-dialog
    :md-active="active"
    style="overflow-y: scroll"
    @md-closed="closeDialog"
    @md-clicked-outside="closeDialog"
  >
    <md-dialog-title class="md-headline">
      {{ isCreateMode ? 'Create Promocode' : 'Edit Promocode' }}
    </md-dialog-title>

    <div class="card-wrapper">
      <md-field class="short-field">
        <label>Code</label>
        <md-input
          v-model="$v.body.code.$model"
          :disabled="!isCreateMode"
        />
        <div
          v-if="$v.body.code.$error"
          class="error-feedback"
        >
          6-50 characters, latin letters, digits and '-'
        </div>
      </md-field>

      <div class="calendar-wrapper">
        <div>
          <label>Starts</label>
          <md-datepicker
            v-model="$v.body.starts_from.$model"
            md-immediately
            class="datepicker"
          />
          <div
            v-if="$v.body.starts_from.$error"
            class="error-feedback"
          >
            Field is required
          </div>
        </div>

        <div>
          <label>Until</label>
          <md-datepicker
            v-model="$v.body.valid_until.$model"
            md-immediately
            class="datepicker"
          />
          <div
            v-if="$v.body.valid_until.$error"
            class="error-feedback"
          >
            Field is required
          </div>
        </div>
      </div>

      <span class="valid-days-counter">Will be valid for {{ $validDuration }} days</span>

      <md-field class="short-field">
        <label>Total number of redeems</label>
        <md-input v-model="$v.body.total_redeemable_number.$model" />
        <div
          v-if="$v.body.total_redeemable_number.$error"
          class="error-feedback"
        >
          Must be a positive integer
        </div>
      </md-field>

      <md-field
        v-if="!isCreateMode"
        class="short-field"
      >
        <label>Total redeemed count</label>
        <md-input
          v-model="$v.body.total_redeemed_count.$model"
          :disabled="!isCreateMode"
        />
        <div
          v-if="$v.body.total_redeemed_count.$error"
          class="error-feedback"
        >
          Must be a positive integer or zero
        </div>
      </md-field>

      <md-field class="short-field">
        <label>Maximum redeem times per one account</label>
        <md-input v-model="$v.body.maximum_redeem_times.$model" />
        <div
          v-if="$v.body.maximum_redeem_times.$error"
          class="error-feedback"
        >
          Must be a positive integer
        </div>
      </md-field>

      <div>Will grant premium for:</div>
      <div class="duration-wrapper">
        <md-field class="short-field">
          <label>Days</label>
          <md-input
            v-model="premiumDurationDays"
            :disabled="!isCreateMode"
          />
        </md-field>
        &
        <md-field class="short-field">
          <label>Hours</label>
          <md-input
            v-model="premiumDurationHours"
            :disabled="!isCreateMode"
          />
        </md-field>
      </div>
      <span class="valid-days-counter">Total: {{ $premiumDuration }} hours</span>
      <br>

      <md-switch v-model="body.isRedeemAllowed">
        Redeem Allowed
      </md-switch>
    </div>

    <md-dialog-actions class="bottom-buttons">
      <md-button
        class="md-success"
        @click="submit"
      >
        Save
      </md-button>
    </md-dialog-actions>
  </md-dialog>
</template>

<script>
import {required, numeric} from "vuelidate/lib/validators";

const CURRENT_DATE = new Date();
const mustBePositive = (value) => value > 0;

export default {
    props: { promocode: { type: Object, default() { return undefined;} }, active: Boolean },
    data() {
        return {
            isCreateMode: false,

            premiumDurationHours: 0,
            premiumDurationDays: 1,

            promocode_id: "",

            body: {}
        };
    },
    computed: {
        $validDuration() {
            return Math.floor((this.body.valid_until - this.body.starts_from) / 86400000);
        },
        $premiumDuration() {
            return (parseInt(this.premiumDurationHours) || 0) + (parseInt(this.premiumDurationDays) || 0) * 24;
        }
    },
    watch: {
        promocode: "updateFromProps"
    },
    mounted() {
        this.updateFromProps();
    },
    methods: {
        submit() {
            this.$v.$touch();
            if (this.$v.$invalid) {
                return;
            }
            this.$v.$reset();

            if (this.isCreateMode) {
                const body = {...this.body};
                body.premium_duration_hours = this.$premiumDuration;
                body.starts_from = this.body.starts_from.toISOString();
                body.valid_until = this.body.valid_until.toISOString();

                this.$http.post("/v1/admin/store/promocode/create", body)
                    .then(() => {
                        this.$notify({
                            group: "foo",
                            title: "Promocode created",
                        });
                        this.closeDialog(true);
                    })
                    .catch((err) => {
                        this.$notify({
                            group: "foo",
                            title: err,
                        });
                    });
            } else {
                const body = {
                    starts_from: this.body.starts_from.toISOString(),
                    valid_until: this.body.valid_until.toISOString(),
                    isRedeemAllowed: this.body.isRedeemAllowed,
                    total_redeemable_number: this.body.total_redeemable_number,
                    maximum_redeem_times: this.body.maximum_redeem_times,
                    promocode_id: this.body.id
                };

                this.$http.post("/v1/admin/store/promocode/update", body)
                    .then(() => {
                        this.$notify({
                            group: "foo",
                            title: "Promocode updated",
                        });
                        this.closeDialog(true);
                    })
                    .catch((err) => {
                        this.$notify({
                            group: "foo",
                            title: err,
                        });
                    });
            }
        },
        updateFromProps() {
            if (this.$props.promocode) {
                this.isCreateMode = false;
                this.body = {...this.$props.promocode};
                this.body.starts_from = new Date(this.body.starts_from);
                this.body.valid_until = new Date(this.body.valid_until);

                this.premiumDurationHours = this.body.premium_duration_hours % 24;
                this.premiumDurationDays = Math.floor(this.body.premium_duration_hours / 24);
            } else {
                this.isCreateMode = true;
                this.body = {
                    code: "",
                    starts_from: CURRENT_DATE,
                    valid_until: CURRENT_DATE,
                    isRedeemAllowed: false,
                    total_redeemable_number: "",
                    total_redeemed_count: "0",
                    maximum_redeem_times: "",
                    premium_duration_hours: ""
                };
            }
        },
        closeDialog(shouldRefresh) {
            this.premiumDurationHours = 0;
            this.premiumDurationDays = 1;
            this.$v.$reset();
            if (shouldRefresh) {
                this.body = {
                    code: "",
                    starts_from: CURRENT_DATE,
                    valid_until: CURRENT_DATE,
                    isRedeemAllowed: false,
                    total_redeemable_number: "",
                    total_redeemed_count: "",
                    maximum_redeem_times: "",
                    premium_duration_hours: ""
                };
            }
            this.$emit("dialogClosed", { shouldRefresh });
        }
    },
    validations: {
        body: {
            code: {
                promoChars: (value) => /^([a-z]|\d|-){6,50}$/gi.test(value),
                required
            },
            starts_from: {
                required
            },
            valid_until: {
                required
            },
            total_redeemable_number: {
                required, numeric, mustBePositive
            },
            total_redeemed_count: {
                numeric, must: (v) => v >= 0, required
            },
            maximum_redeem_times: {
                required, numeric, mustBePositive
            }
        }
    },
};
</script>

<style scoped lang="scss">
    .error-feedback {
      font-size: 12px;
      color: red;
      margin-right: 5px;
    }

    .card-wrapper {
      max-width: 700px;
      margin: 0 24px;
    }

    .short-field {
      max-width: 400px;
    }

    .calendar-wrapper {
      display: flex;
      justify-content: space-between;

      & > div {
        width: 48%;
        margin-bottom: 5px;

        .error-feedback {
          margin-top: -20px;
        }
      }
    }

    .duration-wrapper {
      display: flex;
      justify-content: space-between;
      align-items: center;

      & > div {
        width: 46%;
      }
    }

    .valid-days-counter {
      display: block;
      margin-bottom: 30px;
    }

    .bottom-buttons {
      display: flex;
      justify-content: flex-end;
    }
</style>
